
import { defineComponent } from "vue";

export default defineComponent({
  name: "HelloWorld",
  props: {
    message: String,
  },
});
